import { conversationsApi } from "@/services/conversation-service"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useNavigate } from "react-router-dom";

export const useDeleteConversation = (id: string, currentRouteId?: string) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { mutate } = useMutation({
    mutationFn: () => {
      return conversationsApi.deleteConversation(id)
    }, onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["conversations"] })
      if (currentRouteId && currentRouteId == id) {
        navigate("/playground", { replace: true })
      }

    }
  })
  return { mutate }
}
